module.exports = __webpack_public_path__ + "img/icon_tag_walklog.872471dd.svg";